import BaseResource from './BaseResource';

export default class AnnotationResource extends BaseResource {
  static urlRoot = '/api/v2/annotations';

  markId = '';

  highlightedText = '';

  pk() {
    return this.markId;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/resources/AnnotationResource.js